const BUILD_ID_META_PATTERN = /<meta\s+name="build-id"\s+content="([^"]+)"\s*\/?>/i

export const extractBuildIdFromHtml = (html: string): string | null => {
  const match = html.match(BUILD_ID_META_PATTERN)
  return match?.[1] ?? null
}
